<template>
    <div class="livetip-wrapper" v-if='config_list!= "" || calendarList!= ""'>
      <div class="configs-div" v-if='calendarList == ""'>

        <!--<div class="config-div" @click="go_detail">-->
          <!--<div class="config-left"><img src="../../../static/images/qq.png"></div>-->
          <!--<div class="config-right">-->
            <!--<p>{{msg_introduce}}<van-icon name="arrow" size="14" class="arrow-top" color="#999999"/></p>-->
            <!--<span>请尽快加群下载课程资料，班群解散后不再提供</span>-->
          <!--</div>-->
        <!--</div>-->

        <!--<div @click="go_detail" class="tab-group-box">-->
          <!--<div class="tab-group-left">-->
            <!--<img src="../../../static/images/add.png" class="tab-group-add"/>-->
            <!--<div class="tab-group-txt">添加专属助教，获取优质资料/方法分享</div>-->
          <!--</div>-->
          <!--<div src="../../../static/images/group-tab-more.png" class="tab-group-right"></div>-->
        <!--</div>-->

      </div>
      <!-- <div class="configs-div" v-else>
      <!-- <div class="configs-div" v-else>
        <div class="config-div config-divs" v-for="j in config_list" @click="go_detail(j.key)">
          <div class="config-lefts"><img v-if="j.key==8" src="../../../static/images/qq.png"><img v-else-if="j.key==10" src="../../../static/images/wechat.png"></div>
          <div class="config-rights">
            <p v-if="j.key==8">加入班群，获取优质资料</p><p v-else-if="j.key==10">关注“中公教育学习助手”公众号</p>
            <span v-if="j.key==8">请尽快加群下载课程资料，班群解散后不再提供</span><span v-if="j.key==10">绑定开课手机号，获取直播上课提醒/学习服务</span>
          </div>
          <van-icon name="arrow" size="16" class="arrow-right" color="#999999"/>
        </div>
      </div> -->
      <div class="jiaqun" v-else-if='calendarList.length == 1'>
        <p class="today_live">今日直播<img class="play" src="../../../static/images/play.png">
          <!-- <span @click="go_detail" v-if='config_list!= ""'><img class="icon_p" src="../../../static/images/wechat_s.png">{{msg_introduce}}<img class="arrow" src="../../../static/images/left.png"></span> -->
        </p>
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for='i in calendarList' @click='go_zhibo(i)'>
              <div class="left-div">
                <p class="time">{{getTime(Number(i.start_time)*1000)}}</p>
                <p class="tagtip" v-if="(Number(i.start_time)-3600>new Date().getTime()/1000)">未开始</p>
                <p class="tag" v-if="Number(i.start_time)-3600<new Date().getTime()/1000&&Number(i.start_time)>new Date().getTime()/1000">即将开始</p>
                <p class="tag" v-if="!i.noLivePush&&Number(i.start_time)<new Date().getTime()/1000&&new Date().getTime()/1000<Number(i.end_time)+9000">直播中</p>
                <p class="tagtip" v-if="i.noLivePush&&i.offline_code">看回放</p>
                <p class="tagtip" v-if="i.noLivePush&&i.offline_code==''">已结束</p>
              </div>
              <div class="right-div">
                <p class="lesson-name">{{i.lesson_name}}</p>
                <p class="package-name">{{i.package_name}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jiaqun" v-else>
        <p class="today_live">今日直播<img class="play" src="../../../static/images/play.png">
          <!-- <span @click="go_detail" v-if='config_list!= ""'><img class="icon_p" src="../../../static/images/wechat_s.png">{{msg_introduce}}<img class="arrow" src="../../../static/images/left.png"></span> -->
        </p>
        <div class="single_live">
          <div class="swiper-slide single_div" v-for='i in calendarList' @click='go_zhibo(i)'>
            <div class="left-div">
              <p class="time">{{getTime(Number(i.start_time)*1000)}}</p>
              <p class="tagtip" v-if="(Number(i.start_time)-3600>new Date().getTime()/1000)">未开始</p>
              <p class="tag" v-if="Number(i.start_time)-3600<new Date().getTime()/1000&&Number(i.start_time)>new Date().getTime()/1000">即将开始</p>
              <p class="tag" v-if="!i.noLivePush&&Number(i.start_time)<new Date().getTime()/1000&&new Date().getTime()/1000<Number(i.end_time)+9000">直播中</p>
              <p class="tagtip" v-if="i.noLivePush&&i.offline_code">看回放</p>
              <p class="tagtip" v-if="i.noLivePush&&i.offline_code==''">已结束</p>
            </div>
            <div class="right-div">
              <p class="lesson-name">{{i.lesson_name}}</p>
              <p class="package-name">{{i.package_name}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="class_dialog" v-if='zujian_flag'>
        <div class="dialog_box">
          <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}APP"进行查看</div>
          <p><span @click='cancel_flag'>取消</span>
            <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"' id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid="appid"
              :extinfo="JSON.stringify({'type': 1, 'spuID': goodsId, 'orderSn': sn, 'owner': this.$route.query.owner, 'channel': this.$route.query.channel, 'orgn': this.$route.query.orgn})"
            >
              <script type="text/wxtag-template">
                <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
                </style>
                <div class="btn">去APP查看</div>
              </script>
            </wx-open-launch-app> -->
            <span v-if='android' class="goapp"><a :href="scheme + '?type=1&sso_id='+ sso_id+'&orderSn='+ sn + '&spuID='+ goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn" @click='search_flag'>打开APP</a></span>
            <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
          </p>
        </div>
      </div>
      <popup :type='1' @isopen="popup" class="popop_content" v-if='applets_flag&&ios'></popup>
      <popup :type='2' @isopen="popup" class="popop_content" v-if='applets_flag&&android'></popup>
      <arouse v-if="arshow" @arouse='receive'></arouse>
      <!--<div class="config_mask" v-if="config_flag">-->
        <!--<div class="config_content">-->
          <!--<p class="config_title">加群领资料<img @click="config_flag = false" src="../../../static/images/guanbi.png"></p>-->
          <!--<div class="config_detail">-->
            <!--<div class="out_loop" v-for="i in courseLists.wx_list">-->
              <!--<p class="cid_name">{{i.name}}</p>-->
              <!--<p class="warn_mes">为确保您正常听课，请务必尽快加群下载课程资料<br/>班群解散后不再提供资料</p>-->
              <!--<div class="weixin_img">-->
                <!--<img class="img_link" :src="i.qr">-->
                <!--<img class="hand" src="../../../static/images/hand.png">-->
              <!--</div>-->
              <!--<p class="wenan">微信扫码 邀你进群</p>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="config_detail">-->
            <!--<div v-for="i in courseList.qq_list">-->
              <!--<p class="cid_name">{{i.remark}}</p>-->
              <!--<p class="warn_mes">为确保您正常听课，请务必尽快加群下载课程资料<br/>班群解散后不再提供资料</p>-->
              <!--<div class="qq_config">-->
                <!--<div class="qq_group">-->
                  <!--<img src="../../../static/images/qq_group.png">-->
                  <!--<div class="qq_name">-->
                    <!--<p>QQ群号</p>-->
                    <!--<p>{{i.qq}}</p>-->
                  <!--</div>-->
                <!--</div>-->
                <!--<input class="qq_text" type="text" :value="i.qq">-->
                <!--<p class="copy" @click="copy_text">复制QQ群号</p>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->

    </div>
</template>
<script>
import popup from "../popup/index" //小程序弹窗
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import arouse from '../arouse/index.vue'
import { Toast } from "vant";

export default {
  data() {
    return {
      ticket: '',
      ticket_source: '',
      calendarList: [],
      zujian_flag: false,
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: navigator.userAgent.match(/iPad/) || navigator.userAgent.match(/iPhone/) || navigator.userAgent.match(/iPod/),
      applets_flag: false,
      isapplets: false,
      sf: '',
      appid: '',
      sso_id: '',
      detail: '',
      sn: this.$route.query.order_id,
      scheme: '',
      appname: '',
      goodsId: '',
      config_list: [],
      config_flag: false,
      courseList: [],
      courseLists: [],
      isweixin: false,
      arshow: false,
    }
  },
  props: ['isLiveTip', 'config', 'remind', 'msg_introduce'],
  components: {
    popup,
    arouse
  },
  watch: {
    isLiveTip(val) {
      if(this.isLiveTip){
        this.courselive()
      }
    },
    config(val) {
      for (var i in val) {
        if (val[i].key == 8 || val[i].key == 13) {
          this.config_list.push(val[i])
        }
      }
    },
    remind(val) {
      if (val == 2) {
        this.$api.ADDGROUPREMIND({
          "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
          ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
          system_sn: this.$route.query.order_id
        }).then((res) => {
          console.log(res)
        })
        this.go_detail()
      }
    }
  },
  mounted() {
    // 小程序内
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        this.isapplets = true
      }
    })
    console.log(this.isLiveTip)
    new Swiper('.swiper-container', {
      observer:true, //修改swiper自己或子元素时，自动初始化swiper
    })
    if(!this.$route.query.ticket){
      this.courselive()
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
    this.sso_id = localStorage.getItem("ticketObj") ? JSON.parse(localStorage.getItem("ticketObj")).sso_id : ''
    this.sf = this.$route.query.sf
    this.goodsId = window.sessionStorage.getItem("goodsId")
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '在线课堂'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.scheme = 'zaixianketang://'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.scheme = 'shiyedanwei://'
      this.open_url = 'http://3min-class.offcn.com/videos/h5/download/institution/'
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
      this.scheme = 'zhonggongtiku://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
    } else if (this.sf == 'zgzsb') {
      this.appid = 'wx9487d9bc65834b47'
      this.appname = '中公专升本'
      this.scheme = 'zhonggongzhuanshengben://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
    } else if (this.sf == 'zgyljy'){
      this.appid = 'wxc7238886c470203e'
      this.appname = '中公医疗教育'
      this.scheme = 'zhonggongyiliaojiaoyu://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_yikao'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
      this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
    } else if (this.sf == 'zgyouzhi') {
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
  },
  methods: {
    // 查询直播是否断流
    async checkRoomState (data) {
      return new Promise((resolve, reject) => {
        this.$api.CheckRoomState(data).then((res) => {
          if (res.code === 0) {
            console.log(res.data)
            resolve(res.data)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    handleErrorFn (e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      if (this.sf == 'sydw') {
        window.location.href ="https://xue.offcn.com/institution/";
      } else if (this.sf == 'zgwx') {
        window.location.href ="https://www.eoffcn.com/help/download/online_course.html";
      } else if (this.sf == 'zgzsb') {
        window.location.href ="https://www.offcnzsb.com/zg/scan/";
      } else {
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(
        /MicroMessenger\/([\d\.]+)/i
      );
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    courselive() {
      let that = this
      if (!JSON.parse(localStorage.getItem("ticketObj"))) {
        this.$router.push({ path: "/" })
      }
      this.$api.COURSELIVE({
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        system_order_num: this.$route.query.order_id
      }).then(async (res) => {
        if (res.code === 0) {
          let listData = res.data
          let endLiveList = []
          listData.forEach(e => {
            if (Number(e.end_time) + 9000 > new Date().getTime() / 1000 && Number(e.end_time) < new Date().getTime() / 1000) {
              // 直播结束2.5小时之内
              endLiveList.push({
                roomId: e.room_id,
                endTime: Number(e.end_time)
              })
              that.$nextTick(() => {
                Object.assign(e, {
                  noLivePush: false
                })
              })
            } else if (Number(e.end_time) + 9000 < new Date().getTime() / 1000) {
              // 直播结束2.5小时之外
              that.$nextTick(() => {
                Object.assign(e, {
                  noLivePush: true
                })
              })
            } else {
              // 直播没结束其他情况
              that.$nextTick(() => {
                Object.assign(e, {
                  noLivePush: false
                })
              })
            }
          })
          if (endLiveList.length > 0) {
            await that.checkRoomState({
              rooms: endLiveList.map(a => a.roomId)
            }).then(data => {
              data.forEach(e => {
                if (e.is_push === 0) {
                  that.$nextTick(() => {
                    Object.assign(listData.find(i => i.room_id === e.room_num), {noLivePush: true})
                  })
                  let rIndex = endLiveList.findIndex(b => b.roomId === e.room_num)
                  if (rIndex > -1) {
                    endLiveList.splice(rIndex, 1)
                  }
                }
              })
            })
          }
          let timer = setInterval(async () => {
            endLiveList.forEach(c => {
              if (Number(c.end_time) + 9000 <= new Date().getTime() / 1000) {
                // 超出2.5小时了
                that.$nextTick(() => {
                  Object.assign(listData.find(i => i.room_id === c.room_num), {noLivePush: true})
                })
                let rIndex = endLiveList.findIndex(b => b.roomId === c.room_num)
                if (rIndex > -1) {
                  endLiveList.splice(rIndex, 1)
                }
              }
            })
            if (endLiveList.length > 0) {
              await that.checkRoomState({
                rooms: endLiveList.map(a => a.roomId)
              }).then(data => {
                data.forEach(e => {
                  if (e.is_push === 0) {
                    that.$nextTick(() => {
                      Object.assign(listData.find(i => i.room_id === e.room_num), {noLivePush: true})
                    })
                    let rIndex = endLiveList.findIndex(b => b.roomId === e.room_num)
                    if (rIndex > -1) {
                      endLiveList.splice(rIndex, 1)
                    }
                  }
                })
              })
            } else {
              clearInterval(timer)
            }
          }, 180000)
          this.$nextTick(() => {
            this.calendarList = listData
          })
        } else if (res.code == 2) {
          this.$router.push({ path: "/" })
        }
      })
    },
    getTime(times) {
      return this.addZero(new Date(times).getHours()) + ':' + this.addZero(new Date(times).getMinutes());
    },
    //时间戳处理，不足10补0
    addZero(m) {
      return m < 10 ? "0" + m : m;
    },
    go_zhibo(item) {
      this.$api.GETCATALOG({
        system_order_num: item.system_order,
        package_id: item.course_id,
        coding: item.cid,
        menu_id: item.lesson_id
      }).then((res) => {
        if (res.code == 0) {
          let info = res.data.catalog.info
          if (item.lesson_type == 3) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.goodsId
              if (this.isapplets) {
                this.applets_flag = true
              } else {
                this.zujian_flag = true
              }
            } else {
              location.href = item.url_liveshow
            }
            // this.$router.push({
            //   path: "/livevod",
            //   query: {
            //     order_id: item.system_order,
            //     package_id: item.package_id,
            //     cid: item.cid,
            //     unit_id: item.lesson_id,
            //     live_type: 1,
            //     module_type: 66,
            //     url: item.url_liveshow
            //   }
            // })
          } else if (item.lesson_type == 9) {
            if (item.learning_style && item.learning_style.indexOf(2) == -1) {
              this.detail = item
              this.detail.order_id = this.$route.query.order_id
              this.detail.package_id = item.course_id
              this.detail.cid = item.cid
              this.detail.shopid = this.goodsId
              if (this.isapplets) {
                this.applets_flag = true
              } else {
                this.zujian_flag = true
              }
            } else {
              let liveStatus = null
              // 直播状态 0:未开始 1:即将开始 2:直播中 3:已结束有回放
              if ((Number(item.start_time) - 3600 > new Date().getTime() / 1000)) {
                liveStatus = 0
              } else if (Number(item.start_time) - 3600 < new Date().getTime() / 1000 && Number(item.start_time) > new Date().getTime() / 1000) {
                liveStatus = 1
              } else if (!item.noLivePush && Number(item.start_time) < new Date().getTime() / 1000 && new Date().getTime() / 1000 < Number(item.end_time) + 9000) {
                liveStatus = 2
              } else if (item.noLivePush && item.offline_code) {
                liveStatus = 3
              }

              if (liveStatus === 1 || liveStatus === 2) {
                this.$router.push({
                  path: '/livevod',
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    live_type: 3,
                    module_type: 6,
                    url: info.live_record_url
                  }
                })
              } else if (liveStatus === 0) {
                Toast("直播未开始");
              } else if (liveStatus === 3) {
                this.$router.push({
                  path: '/livevod',
                  query: {
                    order_id: item.system_order,
                    package_id: item.course_id,
                    cid: item.cid,
                    unit_id: item.lesson_id,
                    module_type: 66,
                    url: info.live_record_url
                  }
                })
              } else {
                Toast("暂无回放");
              }
            }
          } else {
            if (this.isapplets) {
              this.applets_flag = true
            } else {
              this.zujian_flag = true
              this.$nextTick(() => {
                var btn = document.getElementById('launch-btn')
                btn.addEventListener('launch', function(e) {
                  this.handleJudgeWechat(); //是否满足跳转app条件
                });
              })
            }
          }
        } else if (res.code == 2) {
          this.$router.push({ path: "/" });
        }
      })
    },
    popup () {
      this.applets_flag = false
    },
    cancel_flag() {
      this.zujian_flag = false;
    },
    search_flag() {
      if(!this.isweixin){
        this.arshow = false;
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          this.openApp('https://www.eoffcn.com/wx_classonline/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'zgtk') {
          this.openApp('https://www.eoffcn.com/zg_questions/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'sydw') {
          this.openApp('https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'zgzsb') {
          this.openApp('https://www.eoffcn.com/zg_zsb/detail/?type=1&sso_id='+this.sso_id+'&orderSn='+ this.sn +'&spuID='+ this.goodsId +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn)
        } else if (this.sf == 'zgjsgc') {
          this.openApp('https://www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi') {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
          }
        } else {
          if (this.android) {
            this.openApp('https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html' + this.sn + '&spuID=' + this.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' + this.$route.query.orgn + '&channelId=225')
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?type=1&orderSn=' + this.sn + '&spuID=' + this.goodsId + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' + this.$route.query.orgn + '&channelId=225'
          }
        }
      }else{
        this.arshow = true;
      }
    },
    receive (val) {
      this.arshow = val
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    },
    go_detail () {
      this.config_flag = true
      this.$api.GETMAP({
        system_order_num: this.$route.query.order_id,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        type: 8
      }).then((res)=>{
        this.courseList = res.data.mall_add_group
      }).catch(()=>{})
      let that = this
      setTimeout(function() {
        that.go_details()
      }, 100)
    },
    go_details () {
      this.$api.GETMAP({
        system_order_num: this.$route.query.order_id,
        "offcn-ticket": JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"],
        ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
        type: 13
      }).then((res)=>{
        this.courseLists = res.data.mall_add_group
      }).catch(()=>{})
    },
    copy_text () {
      var copytext = $(".qq_text");
      console.log(copytext.select()); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      Toast("QQ群号已复制");
    },
    open_qq (key) {
      if (key) {
        location.href = 'https://qm.qq.com/cgi-bin/qm/qr?k='+ key +'&jump_from=webapi'
      }
    }
  }
};
</script>

<style lang="less">
#launch-btn {
  position: absolute;
  right: 0;
  width: 242px;
  height: 68px;
  opacity: 0;
}
.livetip-wrapper {
  /*min-height: 136px;*/
  /*margin-bottom: 40px;*/
  padding: 0 30px;
  .jiaqun {
    border: 1px solid #e5e5e5;
    border-radius: 8px;
    padding: 32px 24px;
  }
  .today_live {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    .play {
      width: 24px;
      height: 22px;
      margin-left: 10px;
    }
    span {
      display: flex;
      justify-content: space-between;
      align-items: center;
	    height: 38px;
      text-align: center;
      line-height: 38px;
      float: right;
      font-size: 20px;
      color: #e60012;
      font-weight: normal;
      background: #fce5e7;
      border-radius: 18px;
      padding: 0 15px;
      .icon_p {
        width: 18px;
        height: 18px;
      }
      .arrow {
        width: 8px;
        height: 12px;
      }
    }
  }
  .single_live {
    display: flex;
    overflow-x: scroll;
  }
  .single_div {
    width: 588px;
    margin-right: 20px;
  }
  .swiper-container {
    height: 100%;
  }
  .swiper-slide {
    display: flex;
    padding: 22px 30px;
    background: #f6f6f6;
    border-radius: 8px;
    .left-div {
      padding-right: 30px;
      border-right: 1px dashed #cccccc;
      .time {
        color: #4a4a4a;
        font-size: 34px;
        text-align: center;
      }
    }
    .right-div {
      width: 66%;
      margin-left: 30px;
    }
    .lesson-name {
      color: #4a4a4a;
      font-size: 28px;
      font-weight: bold;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .package-name {
      color: #999999;
      font-size: 22px;
      margin-top: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tag {
      font-size: 20px;
      margin-top: 10px;
      background: #ffffff;
      border-radius: 5px;
      border: 1px solid #e60012;
      text-align: center;
      color: #e60012;
      padding: 4px 10px;
      display: inline-block;
    }
    .tagtip {
      font-size: 20px;
      margin-top: 10px;
      border-radius: 5px;
      color: #999999;
      border: 1px solid #999999;
      text-align: center;
      padding: 4px 10px;
      display: inline-block;
    }
  }



  .tab-group-box {box-sizing: border-box; width: 720px; height: 66px; padding: 0 24px; background: #f6f6f6; border-radius: 5px; display: flex; flex-direction: row; align-items: center; justify-content: space-between;margin: 0 auto 30px;
    .tab-group-left {display: inline-flex;
      .tab-group-add {width: 30px; height: 30px;margin-right: 15px;}
      .tab-group-txt {font-size: 24px; color: #333333;}
    }
    .tab-group-right {display: inline-block; width: 30px;height: 30px;}
  }


  .configs-div {
    display: flex;
    .config-div {
      width: 100%;
      display: flex;
      padding: 30px;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      .config-left {
        img {
          width: 68px;
        }
      }
      .config-right {
        margin-left: 20px;
        p {
          display: flex;
          align-items: center;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 14px;
        }
        span {
          color: #666666;
        }
      }
    }
  }
  .class_dialog {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .6);
    z-index: 2;
    .dialog_box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 490px;
      line-height: 40px;
      border-radius: 18px;
      transform: translate(-50%, -50%);
      background: #fff;
      .dialog_message {
        text-align: center;
        padding: 30px 30px;
      }
      p {
        display: flex;
        border-top: 1px solid #e5e5e5;
        height: 70px;
        line-height: 70px;
        span {
          flex: 1;
          text-align: center;
        }
        .goapp {
          color: #e60012;
          border-left: 1px solid #e5e5e5;
        }
      }
    }
  }
  .popop_content {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .config_mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    background: rgba(0, 0, 0, .7);
    .config_content {
      position: absolute;
      bottom: 0;
      width: 100%;
      max-height: 1000px;
      background: #ffffff;
      padding: 38px 30px;
      border-radius: 30px 30px 0px 0px;
      overflow-y: scroll;
      .config_title {
        font-size: 32px;
        font-weight: bold;
        color: #333333;
        img {
          float: right;
        }
      }
      .config_detail {
        .cid_name {
          margin-top: 50px;
          text-align: center;
          font-size: 28px;
          font-weight: bold;
          color: #333333;
        }
        .warn_mes {
          text-align: center;
          color: #666666;
          margin-top: 20px;
        }
        .qq_config {
          height: 130px;
          background: #f6f6f6;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          margin-top: 30px;
          .qq_group {
            display: flex;
            align-items: center;
            img {
              width: 70px;
              height: 70px;
              margin-right: 20px;
            }
            .qq_name {
              font-size: 26px;
              font-weight: bold;
            }
          }
        }
        .qq_text {
          position: absolute;
          opacity: 0;
        }
        .copy {
          width: 160px;
          height: 56px;
          text-align: center;
          line-height: 56px;
          background: #ffffff;
          color: #e60012;
          border: 1px solid #e60012;
          border-radius: 8px;
        }
        .get_ziliao {
          height: 78px;
          text-align: center;
          line-height: 78px;
          font-size: 30px;
          color: #ffffff;
          background: linear-gradient(90deg, #dc3021 0%, #e6422c 50%, #ef5437 100%), linear-gradient(#ec533d, #ec533d);
          border-radius: 40px;
          margin-top: 30px;
        }
        .out_loop {
          text-align: center;
          .img_link {
            width: 240px;
            height: 240px;
            margin-top: 30px;
          }
          .wenan {
            font-size: 30px;
            color: #e60012;
            margin-top: 30px;
          }
          .weixin_img {
            position: relative;
            .hand {
              position: absolute;
              bottom: -20px;
              width: 45px;
              height: 46px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/livetip/index.vue